import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f655201a")

_pushScopeId("data-v-f655201a")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "font-12 font-bold padding-top-10" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "padding-left-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("标签：")
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_7 = { class: "padding-top-10 text-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_paragraph_panel = _resolveComponent("paragraph-panel")
  const _component_router_link = _resolveComponent("router-link")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_card = _resolveComponent("el-card")

  return (_openBlock(), _createBlock(_component_el_card, null, {
    default: _withId(() => [
      _createVNode(_component_paragraph_panel, {
        content: _ctx.content,
        onReference: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reference(_ctx.words)))
      }, null, 8, ["content"]),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              target: "_blank",
              to: {name: 'WordsDetail', params: { id: _ctx.words.id }}
            }, {
              default: _withId(() => [
                _createVNode("div", null, "文案库：" + _toDisplayString(_ctx.words.name), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode("div", _hoisted_4, "所属分类：" + _toDisplayString(_ctx.words.category?.name), 1)
          ]),
          _createVNode("div", null, [
            _hoisted_5,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.words.tags, (tag) => {
              return (_openBlock(), _createBlock(_component_el_tag, {
                key: tag.id
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(tag.name), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ])
        ]),
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          (!_ctx.surroundingVisible)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                content: "展开",
                "show-after": 500,
                placement: "bottom",
                effect: "light"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    icon: "el-icon-d-caret",
                    circle: "",
                    onClick: _ctx.showSurrounding
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.surroundingVisible)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 1,
                content: "收缩",
                "show-after": 500,
                placement: "bottom",
                effect: "light"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    icon: "el-icon-aim",
                    circle: "",
                    onClick: _ctx.shrink
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_tooltip, {
            content: "引用",
            "show-after": 500,
            placement: "bottom",
            effect: "light"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_button, {
                size: "small",
                icon: "el-icon-d-arrow-right",
                circle: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.reference(_ctx.words)))
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
})